angular.module( 'acme.view.application.settings.integration.logs', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.settings.integration.logs.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var settingsIntegrationLogs = {
        name: 'application.settings.integration.logs',
        url: '/logs',
        views: {
          "subview-main": {
            controller: 'SettingsIntegrationLogsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/settings/integration/logs/logs.tpl.html'
          }
        },
        data: {
          pageTitle: 'Salesforce Integration',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(settingsIntegrationLogs);
});
